import { useSyncExternalStore } from 'react';

// biome-ignore lint/suspicious/noEmptyBlockStatements: empty subscribe function
const emptySubscribe = () => () => {};

/**
 * Determine if a component has been hydrated at the earliest possible time.
 * This is a legitimate use of the React useSyncExternalStore.
 * See the first link below for details and usage examples.
 *
 * @see https://tkdodo.eu/blog/avoiding-hydration-mismatches-with-use-sync-external-store
 * @see https://react.dev/reference/react/useSyncExternalStore
 * @returns true for post-hydration on client side, false on server.
 */
export function useIsHydrated() {
  return useSyncExternalStore(
    emptySubscribe,
    () => true,
    () => false,
  );
}
